<template>
  <div v-if="qsLaded > 0 && (orderItem.quantity - orderItem.quantityReturn - orderItem.quantityDelivered) > 0" class="item-deliverable-block" :class="{
    enough: qsLaded > 0 && (orderItem.quantity - orderItem.quantityReturn) <= qsLaded,
  }"
  >
    可发{{ qsLaded > (orderItem.quantity - orderItem.quantityReturn - orderItem.quantityDelivered) ? (orderItem.quantity - orderItem.quantityReturn - orderItem.quantityDelivered) : qsLaded }}
  </div>
</template>
<script>
export default {
  props: {
    orderItem: {
      type: Object,
      default () {
        return {
          quantity: 0,
          quantityReturn: 0,
          quantityDelivered: 0,
          itemSources: []
        }
      }
    }
  },
  computed: {
    qsLaded () {
      const sourceLaded = (this.orderItem.itemSources || []).filter(t => t.state === 5).reduce((p, c) => p + c.quantity, 0)
      return sourceLaded > this.orderItem.quantityDelivered ? sourceLaded - this.orderItem.quantityDelivered : 0
    }
  }
}
</script>

<style lang="stylus">
.item-deliverable-block
  display inline-flex
  border 1px solid #70b603
  padding 2px 4px
  color #70b603
  font-size 12px
  text-align center
  line-height 1
  &.enough
    background #70b603
    color #fff
</style>
